import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBinocular = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "binocular" }),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 5.25,
			cy: 18,
			r: 4.5
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M9.75,18V4.125a2.625,2.625,0,0,0-5.156-.7L.911,16.805"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 18.75,
			cy: 18,
			r: 4.5
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M14.25,18V4.125a2.625,2.625,0,0,1,5.156-.7l3.683,13.377"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: 9.75,
			y: 9,
			width: 4.5,
			height: 3
		})
	]
});
export default SvgBinocular;
